/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.o-email-signup .m-notification {
  margin-bottom: 0.9375em;
}
.o-email-signup .a-text-input {
  max-width: 23.125rem;
}
.o-email-signup__buttons {
  display: flex;
  margin-top: 0.9375em;
  align-items: center;
  flex-wrap: wrap-reverse;
  gap: 0.9375em;
}
.o-email-signup .a-btn {
  text-align: inherit;
}
@media only all and (max-width: 37.5em) {
  .o-email-signup .a-label--heading {
    font-size: 1em;
  }
}